import { createAction } from '@wix/communities-blog-client-common';

export const SET_POST_COUNT = 'postListWidgetPostCount/SET';

export const setPostCount = createAction(SET_POST_COUNT);
